import * as React from 'react';
import Button from '../button/button';
import styles from './footer.module.css';

export const Privacy: React.StatelessComponent<any> = props => {
	return (
		<div className="pb-3 text-lg font-roboto">
			<div id="privacyPolicy">
				<div className={styles.leadPrivacy}>
					<div className={styles.anchorContainer}>
						<a href="https://www.assetmark.com/privacy-and-security" target="_blank" rel="noreferrer" className={styles.sb_browser_link}>
							Online Privacy and Security
						</a>
					</div>
					<div className={styles.anchorContainer}>
						<a href="https://www.assetmark.com/client-privacy-policy" target="_blank" rel="noreferrer" className={styles.sb_browser_link}>
							Client Privacy Policy
						</a>
					</div>
					<div className={styles.anchorContainer}>
						<a href="https://www.assetmark.com/california-privacy-policy" target="_blank" rel="noreferrer" className={styles.sb_browser_link}>
							California Privacy Policy
						</a>
					</div>
					<div className={styles.anchorContainer}>
						<a href="https://www.assetmark.com/california-privacy-notice-at-collection" target="_blank" rel="noreferrer" className={styles.sb_browser_link}>
							California Notice at Collection of Personal Information
						</a>
					</div>
				</div>
			</div>
			<div className={styles.btnFlex}>
				<Button
					onClick={props.onCloseModalClick}
					name="CLOSE"
					text="CLOSE"
					disabled={false}
					className={styles.closeBtn}>
				</Button>
			</div>
		</div>
	);
};

export default Privacy;
